export default "__VITE_ASSET__fe2166f5__"